/**
 * Lead tab enum for admin portal leads page
 */
var LeadsTableTab;
(function (LeadsTableTab) {
    LeadsTableTab["ALL"] = "all";
    LeadsTableTab["INBOUND"] = "inbound";
    LeadsTableTab["DIGITAL_RETAIL"] = "digital_retail";
})(LeadsTableTab || (LeadsTableTab = {}));

export { LeadsTableTab };
//# sourceMappingURL=LeadsTableTab.js.map
